// Load jQuery
import './jquery';

let exportUIkit = null;

if (typeof window !== 'undefined') {
  const UIkit = require('uikit/dist/js/uikit');
  const Icons = require('uikit/dist/js/uikit-icons');
  UIkit.use(Icons);
  (<any>window).UIkit = UIkit;
  exportUIkit = (<any>window).UIkit;
}

export default <any>exportUIkit;
